import { useState } from 'react';
import { useAccounts } from '../../../api/super-admin.api';

export function AccountsPage() {
  const [search, setSearch] = useState('');
  const { data, isLoading } = useAccounts();

  const filtered = (data ?? []).filter((a) => {
    if (!search.trim()) return true;
    const q = search.trim().toLowerCase();
    return [a.email, a.name, a.org_id, a.role].some((f) => f.toLowerCase().includes(q));
  });

  return (
    <section style={{
      backgroundColor: 'var(--card-bg)',
      border: '1px solid var(--card-border)',
      borderRadius: 'var(--card-radius)',
      boxShadow: 'var(--card-shadow)',
      overflow: 'hidden',
    }}>
      <header style={{ padding: 'var(--space-4) var(--space-5)', borderBottom: '1px solid var(--color-border-default)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 'var(--space-3)' }}>
        <div>
          <h2 style={{ margin: 0, fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xl)', fontWeight: 'var(--font-weight-bold)', color: 'var(--color-text-brand)' }}>
            All accounts
          </h2>
          <p style={{ marginTop: '2px', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
            {data?.length ?? 0} users across all organisations
          </p>
        </div>
        <input
          type="search"
          placeholder="Search email / org / role…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            height: 'var(--input-height, 38px)',
            width: 280,
            padding: '0 var(--space-3)',
            borderRadius: 'var(--radius-input)',
            border: '1px solid var(--color-border-default)',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-sm)',
          }}
        />
      </header>

      {isLoading && <div style={{ padding: 'var(--space-4)' }}>Loading…</div>}
      {!isLoading && filtered.length === 0 && <div style={{ padding: 'var(--space-4)', color: 'var(--color-text-muted)' }}>No accounts match.</div>}

      {filtered.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)' }}>
            <thead>
              <tr>
                <Th>Email</Th>
                <Th>Name</Th>
                <Th>Org</Th>
                <Th>Role</Th>
                <Th>Last seen</Th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((a) => (
                <tr key={a.jt_user_id}>
                  <Td><code style={{ fontSize: 'var(--text-xs)' }}>{a.email}</code></Td>
                  <Td>{a.name}</Td>
                  <Td><code style={{ fontSize: 'var(--text-xs)' }}>{a.org_id}</code></Td>
                  <Td>{a.role}</Td>
                  <Td>{new Date(a.last_synced_at).toLocaleDateString()}</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

function Th({ children }: { children: React.ReactNode }) {
  return (
    <th style={{
      textAlign: 'left',
      padding: 'var(--space-2) var(--space-4)',
      fontSize: 'var(--text-xs)',
      textTransform: 'uppercase',
      letterSpacing: 'var(--tracking-caps)',
      color: 'var(--color-text-muted)',
      borderBottom: '1px solid var(--color-border-default)',
      whiteSpace: 'nowrap',
    }}>{children}</th>
  );
}

function Td({ children }: { children: React.ReactNode }) {
  return (
    <td style={{ padding: 'var(--space-2) var(--space-4)', verticalAlign: 'middle', borderBottom: '1px solid var(--color-border-subtle, var(--color-border-default))' }}>
      {children}
    </td>
  );
}
